/* eslint-disable import/prefer-default-export */
export const pageData = {
  device: 'mobile',
  env: 'production',
  data: {
    type: 'article',
    adSettings: {
      targeting: {
        client: 'desktop',
        tag: [
          'local'
        ]
      },
      disableAds: false,
      freewheel: {
        sectionId: 'univision_custom_deportes_futbol_uefachampionsleague',
        assetId: null,
        adValue: null,
        test: {
          displayAdProfilePath: 'univision_test',
          host: 'https://1b656.v.fwmrm.net',
          linkTag2Profile: '111976:univision_linktag2_test',
          networkCode: '111976',
          profilePath: 'univision_test_HTML5'
        },
        production: {
          displayAdProfilePath: 'univision_test',
          host: 'https://1b656.v.fwmrm.net',
          linkTag2Profile: 'univision_linktag2_live',
          networkCode: '112214',
          profilePath: 'univision_Live_HTML5'
        }
      },
      dfp: {
        adValue: '/univision_custom_deportes/futbol/uefachampionsleague',
        production: {
          desktopAdValuePrefix: 'rd.',
          mobileAdValuePrefix: 'rios.',
          networkCode: '6881'
        },
        test: {
          desktopAdValuePrefix: 'rd.',
          mobileAdValuePrefix: 'rios.',
          networkCode: '7009'
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/advertising.js